import { isUntrackedPage, trackScreenView } from '@core/analytics'
import { type ScreenId } from '@core/router'

export const trackInitialScreenView = (screenId: ScreenId): void => {
    if (isUntrackedPage(window.location.pathname)) {
        return
    }

    trackScreenView(screenId, true)
}
